import Request from './base/Request';

class UserInfoChangeRequest extends Request {
    constructor(APIURL, header, body) {
        super(APIURL);

        console.log(body)

        this.options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...header
            },
            body: JSON.stringify(body)
        };
        this.request = this.request.bind(this);
    }
}

export default UserInfoChangeRequest;
